import { forwardRef, type SelectHTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
}

export const Select = forwardRef<HTMLSelectElement, Props>(function Select(
  { className, label, id, children, ...rest },
  ref,
) {
  return (
    <label className="block">
      {label && (
        <span className="mb-1 block text-[11px] font-medium text-fg-muted">{label}</span>
      )}
      <select
        ref={ref}
        id={id ?? rest.name}
        className={cn(
          'h-9 w-full rounded-md border border-border bg-white px-2.5 text-sm text-fg focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/20',
          className,
        )}
        {...rest}
      >
        {children}
      </select>
    </label>
  );
});
